export type {
  AlphaColors,
  ColorVariants,
  GlobalSharedColors,
  Greys,
  TextAlignment,
  TextAlignments,
} from './themeDuplicates';
export {
  black,
  blackAlpha,
  brandWeb,
  grey,
  grey10Alpha,
  grey12Alpha,
  grey14Alpha,
  hcButtonFace,
  hcButtonText,
  hcCanvas,
  hcCanvasText,
  hcDisabled,
  hcHighlight,
  hcHighlightText,
  hcHyperlink,
  sharedColors,
  white,
  whiteAlpha,
} from './themeDuplicates';
export { createV8Theme } from './v8ThemeShim';
export { createBrandVariants } from './v9BrandVariantsShim';
export { createV9Theme } from './v9ThemeShim';
